import _ from "lodash";
import client from "lib/apolloClient/client";
import { getStudentGoalsQuery } from "./GoalListQueries";

export const getStudentGoalFeedFromCache = ({ studentId, filters }) => {
  try {
    const queryData = client.readQuery({
      query: getStudentGoalsQuery,
      variables: {
        studentId,
        filters,
      },
      returnPartialData: true,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
